module.exports = __webpack_public_path__ + "img/1.889b9779.png";